import React, {PureComponent} from "react";
import NoContent from "../NoContent/NoContent";
import Analytics from "../../libs/analytics";
import { buildContentQuery, creatorFilter, wrapFilters } from "../../queries/contentQuery";
import Dots from "../../ui/Dots/Dots";
import {Box, Container} from "@mui/material";
import axios from "axios";
import ClientConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import PostModal from "../PostModal/PostModal";
import PostTile from "./PostTile";
import PostTileSkeleton from "./PostTileSkeleton";
import {masonryColumns, splitIntoColumns} from "./masonry";
import {LAYOUT} from "../../configuration/theme";

class GridContent extends PureComponent {
    constructor(props) {
        super(props);
        const {termToSearch, currentAsset} = props;
        this.state = {
            content: null,
            assets: [],
            page: 0,
            currentAsset: currentAsset,
            searchTerm: termToSearch,
            loading: false,
            enableLoading: true,
            openModal: false,
            activePosition: 0,
            columns: masonryColumns()
        }
    }

    componentDidMount() {
        this.loadMoreAssets();
        window.addEventListener("scroll", this.scheduleScroll, {passive: true});
        window.addEventListener("resize", this.onResize, {passive: true});
    }
    componentWillUnmount() {
        if (this.scrollFrame !== null) {
            window.cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = null;
        }
        window.removeEventListener("scroll", this.scheduleScroll);
        window.removeEventListener("resize", this.onResize);
    }

    scrollFrame = null;

    scheduleScroll = () => {
        if (this.scrollFrame !== null) return;
        this.scrollFrame = window.requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.onScroll();
        });
    }

    onResize = () => {
        const columns = masonryColumns();
        if (columns !== this.state.columns) {
            this.setState({columns});
        }
    }

    onClickItem = ({item, index}) =>{
        this.setState({openModal: true, activePosition: index, content: item});
        this.props.onPostChange(true);
        window.scrollTo({top: 0});
    }

    loadMoreAssets = () => {
        const {loading} = this.state;

        if (loading){
            return;
        }
        this.setState({loading: true});
        const {page} = this.state;
        const pageToLoad = page + 1;

        const {category, contentTitle, creator_id, search_tag, sort, setTotal, query, productsFilter} = this.props;


        let content = "";


        let contentFilters = ``;
        let contentSort = "";


        if (contentTitle && contentTitle?.trim() !== "") {
            contentFilters = `{search:{ term: "${contentTitle}", mode: strict }}`;
        }
        if (query && query?.trim() !== "") {
            contentFilters = `{search:{ term: "${query}", mode: flexible, source: extended}}`;
        }
        if (creator_id && creator_id?.trim() !== "") {
            contentFilters = creatorFilter(creator_id);
        }
        if (search_tag && search_tag?.trim() !== "") {
            contentFilters = `{search_tag: "${search_tag}"}`;
        }
        if (category && category !== "All") {
            contentFilters = contentFilters + `,{attribute:{ code: "category", value:"${category}"}}`;
        }
        if (sort) {
            const value = sort;
            if (value === "most_recent") {
                contentSort = `, sort:{name: publish_date, direction: desc}`;
            }
            if (value === "creator_name") {
                contentSort = `, sort:{name: last_name, direction: asc}`;
            }
            if (value === "with_video") {
                contentSort = `, sort:{name: content_type, direction: desc}`;
            }
            if (value === "views") {
                contentSort = `, sort:{name: engagement, direction: desc}`;
            }
        }

        if (contentFilters) {
            content = wrapFilters(contentFilters)
        }else if(productsFilter.length > 0){
            content = `, filter: {

                OR:[ ${productsFilter.map(m=>`{product: ${m}}`).join(",")} ]

            }`
        }


        this.s = buildContentQuery(content, contentSort, pageToLoad);
        const requestQuery = this.s;

        const prefetched = window.__tvpFirstContent;
        const canUsePrefetch = prefetched && !prefetched.claimed && prefetched.query === requestQuery;
        if (canUsePrefetch) prefetched.claimed = true;

        const request = canUsePrefetch
            ? prefetched.promise
            : axios.post(ClientConfigurationHelper.getContentSearchUrl(), {query: requestQuery}, {withCredentials: true});

        request.then(response => {

            const items = response.data.data.content.items.map(item => {

                const attribute = item.attributes?.find?.(f => f.code === "category");
                const category = attribute?.value[0] || "";
                const assetType = {
                    'youtube': 'youtube',
                    'video': 'mp4',
                    'photo': 'photo'
                };
                const buildVideoSrc = video =>{
                    return {
                        src: video.url,
                        file: video.url,
                        mime: "video/mp4",
                        height: video.height,
                        width: video.width
                    }
                }
                const buildSources = asset =>{
                    const {asset_type} = asset;
                    if(asset_type === "youtube"){
                        return {videoId: asset.youtube.youtube_id, thumbnailUrl: asset.youtube.thumbnail}
                    }else if(asset_type === "video"){
                        return {hls: asset.video.hsl, dash: asset.video.dash, sources: asset.video.sources.mp4.map(buildVideoSrc), thumbnails: asset.video.thumbnails}
                    }else{
                        return {sources: asset.photo.sources, thumbnails: asset.photo.thumbnails}
                    }
                }
                const asset = {
                    type: assetType[item?.asset?.asset_type],
                    ...buildSources(item?.asset)
                }
                return {
                    title: item.title,
                    creator: item.creator,
                    creation_date: item.creation_date,
                    duration: item?.asset?.youtube?.duration ?? item?.asset?.video?.duration,
                    uri_stem: item.uri_stem,
                    user_id: item?.creator?.creator_id,
                    description: item.description,
                    id: item.content_id,
                    content_id: item.content_id,
                    category: category,
                    entityType: item.content_type === "video" ? 1 : 7,
                    products: item?.products || [],
                    asset: asset
                };
            });
            const total = response.data.data.content.total || 0;
            if (typeof setTotal === "function" && pageToLoad === 1) {
                setTotal(total);
            }

            const currenItemsLoaded = (pageToLoad - 1) * 12 + items.length;
            if(items.length === 0 || currenItemsLoaded >= total){
                this.setState({enableLoading: false});
            }
            this.setAssetsFromResponse(items);
        }).catch(() => {
            this.setState({loading: false, enableLoading: false});
            this.props.noResultsCallback();
        });
    }

    onScroll = () => {
        const {loading, enableLoading} = this.state;
        if (loading || this.props.paused) return;
        const scrollTo = window.pageYOffset || document.documentElement.scrollTop;
        const newWindowHeight = document.documentElement.offsetHeight - window.innerHeight;
        const percentDocument = (scrollTo * 100) / newWindowHeight;
        if (percentDocument > 80 && enableLoading) {
            this.loadMoreAssets();
        }
    }

    setAssetsFromResponse = (data) => {
        const {assets, page, searchTerm} = this.state;
        //const {data: resData} = response, {result} = resData;


        let newState = {};
        if ((data && data.length)) {
            if (data.length > 0 && this.props.pmEvent && page === 0 && !searchTerm) {
                Analytics.pmEvent(data[0]);
            }
            newState = {
                assets: assets.concat(data),
                page: page + 1
            };
            if (this.props.resultsCallback) {
                this.props.resultsCallback(data);
            }
        } else {
            if (page === 0 && this.props.noResultsCallback)
                this.props.noResultsCallback();
        }
        newState.loading = false;
        this.setState(newState);
    }

    getPostTileFromAsset = (asset, key, column = 0, row = 0) => {
        const {redirect, ratios, variant, card} = this.props;
        const isRail = variant === "rail";
        return <PostTile
            key={asset.id}
            index={key}
            column={column}
            row={row}
            asset={asset}
            ratio={isRail ? "3 / 4" : ratios[key % ratios.length]}
            width={isRail ? {xs: "112px", md: "150px"} : undefined}
            variant={isRail ? "rail" : "masonry"}
            showCreator={isRail}
            card={!isRail && card}
            redirect={redirect}
            onClickItem={this.onClickItem}/>;
    }

    onNext = () =>{
        const {assets, activePosition} = this.state;
        const newItem = activePosition + 1;
        if(assets[newItem]){
            this.setState({
                activePosition: newItem,
                content: assets[newItem]
            })
        }
    }
    onPrev = () =>{
        const {assets, activePosition} = this.state;
        const newIndex = activePosition - 1;
        const newItem = newIndex < 0 ? 0 : newIndex;
        if(assets[newItem]){
            this.setState({
                activePosition: newItem,
                content: assets[newItem]
            })
        }
    }
    onCloseModal = () =>{
        this.setState({openModal: false});
        this.props.onPostChange(false);
    }
    render() {
        const {assets, loading, enableLoading, searchTerm, activePosition, openModal, content} = this.state;
        const {category, sort, redirect, variant} = this.props;
        const filteredBy = category ? "category" : "none";
        const sortedBy = sort ? sort : "none";
        const isMasonry = variant === "masonry";
        const isRail = variant === "rail";
        return (
            <Box data-testid="tvp-grid" data-filteredBy={filteredBy} data-sortedBy={sortedBy}>
                <Container sx={{px: LAYOUT.pagePad, display: openModal ? "none" : undefined}}>
                    {!isRail && (!enableLoading && searchTerm || (!assets || !assets.length && !loading)) && <NoContent>
                        <div className={"no-results"}>No results found.</div>
                    </NoContent>}
                    {isRail ? <Box
                            data-testid="tvp-grid-rail"
                            sx={{
                                display: "flex",
                                gap: "12px",
                                overflowX: "auto",
                                paddingBottom: "6px",
                                scrollSnapType: "x mandatory",
                                "&::-webkit-scrollbar": {height: "8px"},
                                "&::-webkit-scrollbar-thumb": {background: "#C9C9C9", borderRadius: "8px"}
                            }}>
                            {assets.map((asset, key) => this.getPostTileFromAsset(asset, key, key, 0))}
                            {loading && [1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
                                <PostTileSkeleton key={item} width={{xs: "112px", md: "150px"}} />
                            ))}
                    </Box> : <Box
                        data-testid="tvp-grid-masonry"
                        sx={{display: "flex", alignItems: "flex-start", gap: "10px"}}>
                        {splitIntoColumns(assets, this.state.columns, this.props.ratios).map((column, columnIndex) => (
                            <Box key={columnIndex} sx={{flex: 1, minWidth: 0}}>
                                {column.map(({asset, index}, rowIndex) => this.getPostTileFromAsset(asset, index, columnIndex, rowIndex))}
                                {loading && this.props.ratios
                                    .filter((ratio, index) => index % this.state.columns === columnIndex)
                                    .map((ratio, index) => (
                                        <PostTileSkeleton key={`s${index}`} ratio={ratio} />
                                    ))}
                            </Box>
                        ))}
                    </Box>}

                    {isMasonry && !openModal && assets.length > 0 && loading && <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        sx={{padding: "26px 0 6px", fontSize: "13px", color: "#757575"}}>
                        Loading more posts&hellip;
                    </Box>}

                </Container>
                {redirect === false && <PostModal
                    open={openModal}
                    asset={content}
                    position={activePosition + 1}
                    total={assets.length}
                    onPrev={activePosition > 0 ? this.onPrev : undefined}
                    onNext={activePosition < assets.length - 1 ? this.onNext : undefined}
                    onClose={this.onCloseModal}>
                    {content?.creator?.creator_id && <GridContent
                        key={content.creator.creator_id}
                        variant="masonry"
                        creator_id={String(content.creator.creator_id)} />}
                </PostModal>}
            </Box>
        );
    }
}

GridContent.defaultProps = {
    gridTitle: "Watch the latest",
    redirect: true,
    pmEvent: false,
    noResultsCallback: () => {
    },
    resultsCallback: () => {},
    productsFilter: [],
    variant: "masonry",
    card: false,
    paused: false,
    onPostChange: () => {},
    ratios: ["3 / 4", "1 / 1", "9 / 16", "3 / 4", "4 / 5", "1 / 1", "9 / 16", "4 / 5"],
    showNoResults: false,
    lazyLoadingThumbnails: true
};

export default GridContent;
